import React from "react";
import { LuArrowRight, LuMapPin, LuSearch } from "react-icons/lu";
import { StorageTypeContainer } from "../styled/selfService";

const STORAGE_MODE_OPTIONS = [
  {
    key: "direct",
    pickupProduct: false,
    eyebrow: "SELF SERVICE FIND",
    title: "일반 보관 직접찾기",
    desc: "보관 후 메인 화면의 찾기에서 전화번호와 비밀번호로 직접 찾는 방식이에요.",
    note: "찾기 완료 시 보관이 종료돼요",
    Icon: LuSearch,
  },
  {
    key: "pickup",
    pickupProduct: true,
    eyebrow: "EAGLES PARK PICKUP",
    title: "야구장 픽업 보관",
    desc: "시간 제한 없이 맡긴 뒤 경기 종료 후 한화생명 이글스파크 앞에서 짐을 찾는 방식이에요.",
    note: "야구 경기 있는 날만 이용 가능",
    Icon: LuMapPin,
  },
];

const StorageMode = ({ transformValue, pickupProduct, onSelect }) => {
  return (
    <StorageTypeContainer
      className="slideContent storageModeKiosk"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="topBar">
        <div className="topText">
          <div className="topTitle">보관 방식 선택</div>
          <div className="topDesc">
            야구장 픽업 보관으로 맡길지, 키오스크에서 직접 찾는 일반 보관으로 맡길지
            먼저 선택해주세요. 야구장 픽업 보관은 시간 제한 없이 맡길 수 있어요.
          </div>
        </div>

        <div className="topTotal">STEP 1</div>
      </div>

      <div className="modeGrid">
        {STORAGE_MODE_OPTIONS.map((option) => {
          const Icon = option.Icon;
          const isSelected = pickupProduct === option.pickupProduct;

          return (
            <div
              key={option.key}
              className={`modeCard ${option.key} ${isSelected ? "selected" : ""}`}
              role="button"
              tabIndex={0}
              aria-pressed={isSelected}
              onClick={() => onSelect(option.pickupProduct)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelect(option.pickupProduct);
                }
              }}
            >
              <div className="modeInner">
                <div className={`modeBadge ${option.key}`}>{option.eyebrow}</div>

                <div className={`modeIconWrap ${option.key}`} aria-hidden="true">
                  <Icon />
                </div>

                <div className="modeTitle">{option.title}</div>
                <div className="modeDesc">{option.desc}</div>
                <div className="modeNote">{option.note}</div>

                <div className="modeFooter">
                  <span className="modeState">
                    {isSelected ? "선택됨" : "이 방식으로 진행"}
                  </span>
                  <span className="modeArrow" aria-hidden="true">
                    <LuArrowRight />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="modeGuide">
        선택 후 다음 버튼을 누르면 보관 수량 선택 단계로 넘어가요.
      </div>
    </StorageTypeContainer>
  );
};

export default StorageMode;
